import { useTvViewershipStore } from "@/stores/TvViewershipStore";

export const TvViewershipStores = [useTvViewershipStore];

export const TvViewershipChannel = {
  received(payload) {
    if (payload.id === this.tvViewershipStore.networksTaskId) {
      this.tvViewershipStore.loadingNetworks = false;
      this.tvViewershipStore.networks = payload.data.networks;
      this.tvViewershipStore.networksTaskId = undefined;
    }
    if (payload.id === this.tvViewershipStore.callsignsTaskId) {
      this.tvViewershipStore.loadingCallsigns = false;
      this.tvViewershipStore.callsigns = payload.data.callsigns;
      this.tvViewershipStore.callsignsTaskId = undefined;
    }
    if (payload.id === this.tvViewershipStore.programsTaskId) {
      this.tvViewershipStore.loadingPrograms = false;
      this.tvViewershipStore.programs = payload.data;
      this.tvViewershipStore.programsTaskId = undefined;
    }
    if (payload.id === this.tvViewershipStore.timesTaskId) {
      this.tvViewershipStore.loadingTimes = false;
      this.tvViewershipStore.programTimes = payload.data.time_ranges;
      this.tvViewershipStore.timesTaskId = undefined;
    }
    if (payload.id === this.tvViewershipStore.datesTaskId) {
      this.tvViewershipStore.loadingDates = false;
      this.tvViewershipStore.dates = payload.data.dates;
      this.tvViewershipStore.datesTaskId = undefined;
    }
  },
};
